import api from 'api'
import { UserPermission } from './permissions'

export type WhoamiPermission = {
  id: number
  permission: UserPermission
  effectiveAt: string
  expiresAt: string | null
}

export type WhoamiCompanyScope = {
  id: number
  companyId: number | null
  companyGroupId: number | null
  allCompanies: boolean
  effectiveAt: string
  expiresAt: string | null
}

export type WhoamiResponse = {
  permissions: WhoamiPermission[]
  companyScopes: WhoamiCompanyScope[]
}

export async function getWhoami(): Promise<WhoamiResponse> {
  const result = await api.get<WhoamiResponse>('/admin/permissions/whoami')
  return result.data
}
